import { Helmet } from 'react-helmet'
import { siteName } from '../helpers/consts'

import TopSection from "../components/MainPage/TopSection";
import SystemSection from "../components/MainPage/SystemSection";
import InvestmentsSection from "../components/MainPage/InvestmentsSection";
// import BlogSection from "../components/MainPage/BlogSection";
import BusinessControlSection from "../components/MainPage/BusinessControlSection";

export default function MainPage() {
  return (
    <>
      <Helmet>
        <title>{siteName}</title>
      </Helmet>

      <TopSection />
      <SystemSection />
      <InvestmentsSection />
      {/* <BlogSection /> */}
      <BusinessControlSection />
    </>
  );
}
